import React, { useState } from "react";
import { Modal, Form, Row, Col, Input, message } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { IRequirementType } from "./types";
import { saveOrUpdate } from "../actions/dimensionsAndType";
const { TextArea } = Input;

interface IProps extends FormComponentProps {
    record?: IRequirementType;
    onClose: (reload?: boolean) => void;
}

function FormRequirementType({ record, form, onClose }: IProps) {
    const [isSaving, setIsSaving] = useState(false);

    function handleOk() {
        form.validateFields((err, values) => {
            console.log("values", values);
            if (!err) {
                setIsSaving(true);

                const objToSave = record
                    ? {
                          id_tipo_requisito: record.id_tipo_requisito,
                          activo: true,
                          versao: record.versao !== "" ? record.versao + 1 : 1,
                      }
                    : {
                          versao: 1,
                      };

                const data = JSON.stringify({
                    tipo_requisito: {
                        ...values,
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_tipos_requisitos.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const { getFieldDecorator } = form;
    const title = record ? "Editar tipo de requisito" : "Novo tipo de requisito";

    return (
        <Modal title={title} visible onOk={handleOk} onCancel={() => onClose()} width="50%" confirmLoading={isSaving}>
            <Form layout="vertical" onSubmit={handleOk}>
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Designação">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Descrição">
                            {getFieldDecorator("descricao", {
                                initialValue: record?.descricao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormRequirementType = Form.create<IProps>({
    name: "form_requirement_type",
})(FormRequirementType);
